import { render, staticRenderFns } from "./BrowseBrands.vue?vue&type=template&id=1d33301e&scoped=true&"
import script from "./BrowseBrands.vue?vue&type=script&lang=ts&"
export * from "./BrowseBrands.vue?vue&type=script&lang=ts&"
import style0 from "./BrowseBrands.vue?vue&type=style&index=0&id=1d33301e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d33301e",
  null
  
)

export default component.exports